/**
 * Banner Mobile Title Formatter
 * Automatically breaks banner titles with 2+ words into 2 lines on mobile screens
 * so the text stays cleanly aligned on the left without overlapping right-side imagery.
 */
(function() {
  function formatBannerHeadings() {
    const headings = new Set();

    // Specific banner title selectors
    document.querySelectorAll(
      '.text-block--text_tqQTNE h1, .text-block--text_tqQTNE h2, ' +
      '.collection-list-hero-banner__title, .collection-list-header-banner__title, ' +
      '.contact-hero-banner__title, [class*="ai-hero-banner__headline"], .about-cta-banner__title'
    ).forEach(function(el) {
      headings.add(el);
    });

    // Any heading inside sections with background media/images
    document.querySelectorAll('.section, .section-wrapper').forEach(function(section) {
      const bg = section.querySelector('.custom-section-background');
      if (bg) {
        const hasMedia = bg.querySelector('img, picture, video') || 
                         bg.style.backgroundImage || 
                         (bg.getAttribute('style') && bg.getAttribute('style').includes('background'));
        if (hasMedia) {
          const h = section.querySelector('.section-content-wrapper h1, .section-content-wrapper h2, .text-block h1');
          if (h) headings.add(h);
        }
      }
    });

    headings.forEach(function(heading) {
      const originalText = heading.getAttribute('data-original-banner-title') || heading.textContent.trim();
      if (!heading.hasAttribute('data-original-banner-title')) {
        heading.setAttribute('data-original-banner-title', originalText);
      }

      if (!originalText) return;

      const words = originalText.split(/\s+/).filter(Boolean);
      if (words.length >= 2) {
        let line1 = '';
        let line2 = '';

        if (words.length === 2) {
          line1 = words[0];
          line2 = words[1];
        } else if (words.length === 3 || words.length === 4) {
          line1 = words.slice(0, 2).join(' ');
          line2 = words.slice(2).join(' ');
        } else {
          const mid = Math.ceil(words.length / 2);
          line1 = words.slice(0, mid).join(' ');
          line2 = words.slice(mid).join(' ');
        }

        heading.innerHTML = line1 + '<span class="banner-title-desktop-space"> </span><br class="banner-title-mobile-break">' + line2;
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', formatBannerHeadings);
  } else {
    formatBannerHeadings();
  }

  window.addEventListener('load', formatBannerHeadings);
  document.addEventListener('shopify:section:load', formatBannerHeadings);
})();
